import React, { useState, useContext } from 'react'
import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import { MenuItem, ListItemText, Select, IconButton } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import WarningIcon from '@flatsy/core/Icon/Warning'
import theme from '@flatsy/core/MuiTheme/theme'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { FileContext } from 'src/containers/Application/Files/Context'
import {
  requiredUploadToFlatArray,
  restrictedWithUploadedFiles,
} from '@flatsy/utils/Functions/Files/RequiredUpload'
import { KindTranslate, FilesKind } from '@flatsy/types/Files'
import { useMobile } from 'src/hooks/Mobile'
import i18n from '@flatsy/utils/translations'
import useStyles from './Style'
import { UploadedItemType } from './Type'
import UploadedItemMobile from './Mobile'

const UploadedItem: React.FC<UploadedItemType> = ({ file }) => {
  const classes = useStyles()
  const isMobile = useMobile()
  const { Uppy } = useContext(FileContext)
  const [kind, setKind] = useState<string>(file.kind || '')
  const {
    applicants: { current },
    files: { filesByApplicant },
  } = useContext(FileContext)

  const UppyFiles = Uppy?.formatedFiles
  const handleKindChange = (event: any) => {
    const val = event.target.value as FilesKind
    Uppy?.updateFormatedFiles(file.id, val)
    setKind(val)
  }

  const createList = () => {
    const filterFilesApplicant = requiredUploadToFlatArray(current?.required_uploads)
    const required = restrictedWithUploadedFiles(filterFilesApplicant, filesByApplicant, {
      UppyFiles,
      currentFile: file,
    })

    const sortRequired = required.filesKinds.sort((a, b) => {
      if (KindTranslate[a] < KindTranslate[b]) {
        return -1
      }
      if (KindTranslate[a] > KindTranslate[b]) {
        return 1
      }
      return 0
    })

    const getKindTranslation = (status: FilesKind) => {
      switch (status) {
        case FilesKind.PROOF_OF_ID_IDENTITY_CARD:
          return i18n.t('french_or_foreign_ID_card')
        case FilesKind.PROOF_OF_ID_DRIVING_LICENCE:
          return i18n.t('french_or_foreign_driving_licence')
        case FilesKind.PROOF_OF_ID_PASSPORT:
          return i18n.t('french_or_foreign_passport')
        case FilesKind.PROOF_OF_RESIDENCE_ELECTION:
          return i18n.t('statement_of_address')
        case FilesKind.TAX_NOTICE:
          return i18n.t('tax_notice')
        case FilesKind.PROOF_OF_WORK_URSSAF:
          return i18n.t('urssaf_self_employed_person')
        case FilesKind.PROOF_OF_REVENUE_BALANCE:
          return i18n.t('accounting_activity_report')
        case FilesKind.PROOF_OF_WORK_D1_EXTRACT:
          return i18n.t('original_d1_extract')
        case FilesKind.PROOF_OF_WORK_K_EXTRACT:
          return i18n.t('original_k_or_k_bis_extract')
        case FilesKind.PROOF_OF_WORK_RETIREMENT:
          return i18n.t('last_statement_of_arrears_or_pension_notification')
        case FilesKind.PROOF_OF_WORK_BENEFITS:
          return i18n.t('certificate_of_unemployment')
        case FilesKind.PROOF_OF_REVENUE_BENEFITS:
          return i18n.t('proof_of_payment_of_benefits')
        case FilesKind.PROOF_OF_RESIDENCE_HOSTED:
          return i18n.t('certificate_of_accommodation')
        case FilesKind.PROOF_OF_WORK_CERTIFICATE:
          return i18n.t('employer_certificate')
        case FilesKind.PROOF_OF_REVENUE_SALARY:
          return i18n.t('pay_slip')
        case FilesKind.PROOF_OF_ID_RESIDENCE_PERMIT:
          return i18n.t('residence_card')
        case FilesKind.PROOF_OF_RESIDENCE_OWNER:
          return i18n.t('last_property_tax')
        case FilesKind.PROOF_OF_RESIDENCE_RENT:
          return i18n.t('rent_receipt')
        default:
          return status
      }
    }
    return sortRequired.map((doc) => {
      return (
        <MenuItem key={doc} value={doc}>
          <ListItemText primary={getKindTranslation(doc)} />
        </MenuItem>
      )
    })
  }

  const handleTrash = () => {
    Uppy?.removeFile(file.id)
  }

  if (isMobile) {
    return <UploadedItemMobile file={file} />
  }

  return (
    <div className={classes.container}>
      <Body1 className={classes.fileName}>{file.name}</Body1>
      <div className={classes.selectContainer}>
        {kind && kind !== '' ? (
          <DoneIcon className={classes.done} />
        ) : (
          <WarningIcon className={classes.warning} color={theme.palette.warning.main} />
        )}
        <Select
          value={kind}
          onChange={handleKindChange}
          className={classes.select}
          variant="outlined"
          displayEmpty
        >
          <MenuItem value="" disabled>
            {i18n.t('type_of_document')}
          </MenuItem>
          {createList()}
        </Select>
      </div>
      <div className={classes.actionContainer}>
        <IconButton
          aria-controls="delete-file"
          aria-haspopup="false"
          target="_blank"
          href={file.previewUrl}
          className={classes.actionInner}
        >
          <VisibilityIcon className={classes.actionIcon} />
        </IconButton>
        <IconButton
          className={classes.actionInner}
          aria-controls="delete-file"
          aria-haspopup="false"
          onClick={handleTrash}
        >
          <DeleteForeverIcon className={classes.actionIcon} />
        </IconButton>
      </div>
    </div>
  )
}

export default UploadedItem
